import { Stack, StackItem } from '@optimus-web/core';
import { LoyaltyMembershipTag, UseSortedLoyaltyMembershipsParams, useSortedLoyaltyMemberships } from '../../common';
import { MoreItemsLink, MoreItemsLinkProps } from './MoreItemsLink';

type AccountLoyaltyProps = Pick<MoreItemsLinkProps, 'onClick'> & UseSortedLoyaltyMembershipsParams;

export const AccountLoyalty = ({ onClick, loyaltyMemberships }: AccountLoyaltyProps) => {
    const loyaltyMembershipItems = useSortedLoyaltyMemberships({ loyaltyMemberships });
    const first = loyaltyMembershipItems[0];

    if (!first) return null;

    const count = loyaltyMembershipItems.length - 1;

    if (count === 0) {
        return (
            <StackItem contentFit>
                <LoyaltyMembershipTag {...first} />
            </StackItem>
        );
    }

    return (
        <Stack spacing="100" itemAlignment="center">
            <LoyaltyMembershipTag {...first} />
            <MoreItemsLink count={count} onClick={onClick} />
        </Stack>
    );
};
